import React, { FC, useEffect, useRef, useState } from "react";
import { Button, Table, Input, message, Upload, Checkbox, Tooltip, notification, Image } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatInt, formatNum, formatDiscount } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ISCMSDcGoodsDetail } from "../../assetsEntryTypes";
import { useAssetsEntryDetailsModel } from "./assetsEntryDetailsModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { CloseOutlined, ExclamationCircleOutlined, PlusCircleOutlined, PlusSquareTwoTone } from '@ant-design/icons';
import { warehouseService } from "@/views/base/warehouseManage/warehouseService";
import { assetsEntryService } from "../../assetsEntryService";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";
import { importPropsConfig } from "@/utils/importFile";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { UploadChangeParam, UploadFile } from "antd/lib/upload/interface";
import { fileDownload } from "@/utils/exportFile";
import YhTootip from "@/components/YhTootip";
import { AddWarehouseShelfModal } from "./AddWarehouseShelfModal";

type ISCMSDcGoodsSearch = {
    data: ISCMSDcGoodsDetail[],
    isSearch: boolean
}

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { warehouseList, setLoadingInfo, shopAndOrg } = useGlobalModel();
    const { getSelectedDictValueOne, getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);
    const { addGoodsList, addFormVal, editFormVal, editFormVal: { status }, setHistoryVisible, historyRow, historyVisible, setButtonControl,
        setHistoryRow, setAddGoodsList, editGoodsList, setEditGoodsList, setSaveBtn, setAddGoodsModal, downloadTpl, transformsToSDcGoods } = useAssetsEntryDetailsModel();
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedRowRows, setSelectedRowRows] = useState<any>([]);
    const [searchParms, setSearchParms] = useState<string>("");
    const [searchVal, setSearchVal] = useState<ISCMSDcGoodsSearch>({ data: [], isSearch: false });   //用于搜索展示的数据
    const formRef = useRef<any>()


    const importCallback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false, txt: '' })
        if (list && list.length) {
            let str = ""
            let newData: any = []
            list.map((list, index) => {
                if (list.status) {
                    list.details.map((item) => {
                        newData.push({
                            barCode: item.barCode,
                            id: item.id,
                            num: 1,
                            code: item.materialCode,
                            name: item.materialName,
                            typeCode: item.typeCode,
                            typeName: item.typeName,
                            model: item.model,
                            purchasePrice: item.price,
                            unitCode: item.unitCode,
                            unitName: item.unitName,
                            warehouseCode: item.warehouseCode,
                            shelfCode: item.shelfCode,
                            brandName: item.brandName,
                            warehouseName: item.warehouseName,
                            amount: item.amount,
                        })
                    })
                }
                else {
                    str += `【第${index + 1}条导入失败：${list.msg}】`;
                }
            })
            transformsToSDcGoods(newData, mode)
            str ? notification.warning({ message: '提醒', description: str, duration: 9 }) : message.success("导入成功")
        }
    }
    const [addShelfVisible, setAddShelfVisible] = useState<boolean>(false);
    const handleOpenAddShelf = async () => {
        setAddShelfVisible(true);
    }
    //删除商品
    const onRemove = () => {
        if (!selectedRowKeys.length) {
            message.warning("请选择你要删除的商品");
            return;
        }
        mode === "edit" ?
            setEditGoodsList(origin => origin.filter(item => selectedRowKeys.indexOf(item.temporaryId) < 0)) :
            setAddGoodsList(origin => origin.filter(item => selectedRowKeys.indexOf(item.temporaryId) < 0));

        let newSearchData = searchVal.data.filter(item => selectedRowKeys.indexOf(item.temporaryId) < 0)
        setSearchVal({ data: newSearchData, isSearch: searchVal.isSearch });
        mode === "add" ? setButtonControl(false) : setButtonControl(true)
        setSelectedRowKeys([]);
        message.success("删除成功");
    }
    const deleteImg = (value) => {
        globalPrompt("modal", {
            title: '物资图片删除',
            type: 'warning',
            text: `您是否删除${value.materialCode}物资图片？`,
            okText: '确认',
            onOk: debounce(async () => {
                try {
                    let result = await assetsEntryService.deleteImg({
                        code: value.materialCode,
                        md5: "",
                        fileName: ""
                    });
                    result && message.success('物资图片删除成功！');
                    handleSave({ ...value, fileList: [], md5: '', fileName: '' })
                } catch (error) {
                    message.error('物资图片删除失败！')
                }
            }, 500),
            cancelText: '取消',
            onCancel: () => { },
        })
    }

    const onPreview = async (file, res) => {
        try {
            if (file.status === 'done') {
                if (file.response.retCode == 0) {
                    const data = {
                        name: file.name,
                        size: file.size,
                        type: file.type,
                        uid: file.response.retData,
                    }
                    let result = await assetsEntryService.deleteImg({
                        code: res.materialCode,
                        md5: data.uid,
                        fileName: data.name
                    });
                    result && message.success('物资图片添加成功！');
                    handleSave({ ...res, fileList: [data], md5: data.uid, fileName: data.name, })
                } else {
                    message.error('图片上传失败，请重新上传!')
                }
            }

        } catch (error) {
            message.error('物资图片添加失败！')
        }

    }
    //打印标签
    const printGoodTip = async () => {
        if (!selectedRowRows.length) {
            message.warning("请选择你要打印的商品");
            return;
        }
        let materialNamelist: string[] = []
        let details: any = []
        selectedRowRows.map((item) => {
            materialNamelist.push(item.materialName)
            details.push({
                barCode: item.barCode,
                user: item.user,
                departmentName: item.departmentName,
                materialName: item.materialName
            })

        })
        globalPrompt('modal', {
            title: '打印标签',
            type: 'warning',
            text: `您是否打印${materialNamelist.toString()}标签？`,
            okText: '确认',
            onOk: debounce(async () => {
                try {
                    let result = await assetsEntryService.printGoodTip({
                        details,
                        type: "assets.storage"
                    });
                    result && message.success('标签打印成功！')
                } catch (error) {
                    message.error('标签打印失败！')
                }
            }, 500),
            cancelText: '取消',
            onCancel: () => { },
        })

    }
    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<any>([]);
    const changeshelfCode = async (value, options) => {
        let newRecords: any = []
        let params = {
            pageSize: 99999,
            pageNum: 1,
            ...shopAndOrg,
            warehouseId: warehouseList.find((item) => item.value === value.warehouseCode)?.id,
            warehouseCode: value.warehouseCode,
            enable: "1"
        }
        const { retData: shelfAll } = await warehouseService.shelfAllPage(params)
        newRecords = shelfAll.map((item) => { return { ...item, label: (item.code as string), value: item.code, } })
        setShelfAllList(newRecords);
    }
    //搜索  前端自己保存搜索的值， 搜索值为空还是用缓存
    const goodsFilter = (dataSource: ISCMSDcGoodsDetail[] | null = null) => {
        const isEtit = mode !== "add";
        let goodsList = dataSource ? dataSource : [...(isEtit ? editGoodsList : addGoodsList)];
        if (searchParms) {
            let reg = new RegExp(searchParms);
            let arr: ISCMSDcGoodsDetail[] = [];
            goodsList.forEach(item => {
                if (item.materialCode?.match(reg) || item.materialName?.match(reg)) {
                    arr.push(item);
                }
            })

            setSearchVal({ data: arr, isSearch: true });


            if (!arr.length) {
                message.warning("列表没有该商品！！")
                setSearchVal({ data: [], isSearch: false });

            }
        } else {
            setSearchVal({ data: [], isSearch: false });
        }
    }


    // 新增
    const onAdd = () => {
        setAddGoodsModal(true)
    }

    const action = <div className="flex justify-between white-space">
        <div>
            {mode == 'add' && <><Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onAdd}
                disabled={mode !== 'add'}
            >新增物品</Button>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => onRemove()}
                    disabled={mode !== 'add'}
                >删除物品</Button>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={mode !== 'add'}
                    onClick={downloadTpl}
                >下载模板</Button>
                <Upload disabled={mode !== 'add'} showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/assets/assets/importDetails`, importCallback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中..." }), false)}>
                    <Button className="mr-5" type="link" shape="round" disabled={mode !== 'add'}>导入</Button>
                </Upload>
            </>}
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => printGoodTip()}
            >打印标签</Button>
        </div>
        <div className="flex">
            <Input
                size="small"
                allowClear
                datatype="round"
                className="border-r-8 ml-10"
                placeholder="物资编号/物资名称"
                onChange={(e) => { setSearchParms(e.target.value) }}
                onBlur={(e) => setSearchParms(e.target.value?.trim())}
            // onPressEnter={() => goodsFilter()}
            />
            <Button type="primary" style={{ margin: "0px 12px 0px 15px" }} shape="round" onClick={() => goodsFilter()}> 查询</Button>
        </div>
    </div>;


    const columns = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        },
        {
            title: '物资图片',
            width: 140,
            align: "center",
            fixed: "left",
            render: (text, records) =>
            (records.md5 ? <>
                <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '50px', maxHeight: '70px' }} />
                {mode !== 'look' &&
                    <CloseOutlined onClick={() => deleteImg(records)} style={{ color: 'red', fontSize: '14px', position: 'absolute', right: '10px', cursor: 'pointer' }} />}</>
                : <Upload
                    name="file"
                    disabled={mode == 'look'}
                    action={getBaseImgUploadUrl()}
                    data={getBaseUploadData()}
                    // listType="picture"
                    onChange={(info: UploadChangeParam<UploadFile<any>>) => onPreview(info.file, records)}
                    showUploadList={false}
                    beforeUpload={(file) => {
                        let fileEnd: string = file.name.substring(file.name.lastIndexOf("."));
                        let filetypes: string[] = [".jpg", ".png", ".jpeg", "svg", ".gif"];
                        let isType = filetypes?.includes(fileEnd);
                        // if (!isType) {
                        //     message.error('不支持该格式的上传,当前仅支持.jpg", ".png", ".jpeg", "svg", ".gif"类型文件');
                        // }
                        const isLt20M = file.size / 1024 / 1024 < 20
                        if (!isLt20M) {
                            message.error('上传到文件不能超过20M')
                        }
                        // return isType && isLt20M
                        return isLt20M
                    }}
                > <PlusCircleOutlined style={{ color: 'blue', fontSize: '22px', cursor: 'pointer' }} />
                </Upload>
            )
        },
        {
            title: '物资编码',
            width: 140,
            dataIndex: 'materialCode',
        },
        {
            title: '物资名称',
            width: 160,
            dataIndex: 'materialName',
        },
        {
            title: '物资类型',
            width: 100,
            dataIndex: 'typeCode',
            render: (text: string) => getTreeNodeName(text) ?? ''
        },
        {
            title: '规格型号',
            width: 130,
            dataIndex: 'model',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '单位',
            width: 80,
            dataIndex: 'unitCode',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((item) => item.value === text)?.label ?? '',
        },
        {
            title: '单价',
            width: 90,
            dataIndex: 'price',
            editable: true,
        },
        {
            title: '数量',
            width: 70,
            dataIndex: 'num',
        },
        {
            title: '合计',
            width: 120,
            dataIndex: 'amount',
            render: (text: string) => <span>{formatNum(text)}</span>,
        },
        {
            title: '品牌',
            width: 120,
            dataIndex: 'brandName',
        },
        {
            title: '仓库',
            width: 130,
            dataIndex: 'warehouseCode',
            editable: true,
            editType: 'select',
            options: warehouseList,
            // onSelectChange:changeWarehouseCode,
            render: (text: string) => warehouseList.find((item) => item.value === text)?.label ?? '请选择仓库',
        },
        {
            title: <span>货位
                <PlusSquareTwoTone
                    twoToneColor="#1890ff"
                    style={{ cursor: 'pointer', margin: '0 5px', fontSize: '15px' }}
                    onClick={() => {
                        handleOpenAddShelf()
                    }}
                /></span>,
            width: 130,
            dataIndex: 'shelfCode',
            editable: true,
            editType: 'select',
            options: shelfAllList,
            onSelectFocus: changeshelfCode,
            render: (text: string) => text ?? '请选择仓库',
        },
        {
            title: '条形码',
            width: 100,
            dataIndex: 'barCode',
        },
        {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: true,
        },

    ]

    const newSelectColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col?.rules,
                options: col?.options,
                editType: col?.editType,
                editable: mode !== 'add' ? false : col?.editable,
                onSelectChange: col?.onSelectChange,
                onSelectFocus: col?.onSelectFocus,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑   (计算价格)
    const handleSave = (row: ISCMSDcGoodsDetail) => {

        let dataSource = mode === "edit" ? editGoodsList : addGoodsList
        const index = dataSource.findIndex((item) => row.temporaryId ? row.temporaryId === item.temporaryId : row.id === item.id);
        const item = dataSource[index];
        if (row.changeFields == "warehouseCode") {
            row.warehouseName = warehouseList.find((item) => item.value === row.warehouseCode)?.label
            row.shelfCode = ""
        }
        if (row.changeFields == "price") {
            row.amount = row.price
        }
        dataSource.splice(index, 1, { ...item, ...row });
        mode === "edit" ? setEditGoodsList([...dataSource]) : setAddGoodsList([...dataSource]);
        //判断展示的是搜索后的数据，然后搜索的也改变
        if (searchVal.isSearch) {
            goodsFilter(dataSource)
        }
        setButtonControl(true)
        setSaveBtn(true)
    }

    return (
        <YhBox title="" action={action} style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.temporaryId}
                rowClassName={(record) => {
                    if (!record?.isHave || record.error) return "editable-row yh-edit-table-tr background-FFB4B4";
                    return "editable-row yh-edit-table-tr"
                }}
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMSDcGoodsDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                        setSelectedRowRows(selectedRows)
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns as ColumnsType<ISCMSDcGoodsDetail>}
                dataSource={searchVal.isSearch ? searchVal.data : mode === "add" ? addGoodsList : editGoodsList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />

            <AddWarehouseShelfModal
                visible={addShelfVisible}
                onCancel={() => setAddShelfVisible(false)}
            />
        </YhBox>
    )
}